export const initialState = {
    // currentUser: {}
    // loggedIn: false,
    usrMenu: {}
};
const usermenuReducer = (state = { ...initialState }, action) => {
    switch (action.type) {
        case 'USERMENU_SET':
            // return { ...state, currentUser: action.payload }
            return {
                // loggedIn: true,
                usrMenu: { ...action.payload }
            }
        case 'USERMENU_DESTROY':
            // return { ...state, currentUser: {} }
            return {
                // loggedIn: false,
                usrMenu: {}
            }
        default:
            return state;
    }
};
export default usermenuReducer;
